import { useEffect } from 'react';

const useIntersectionObserver = (setActiveHeading: (headingId: string) => void) => {
  useEffect(() => {
    const handleObserverUpdates = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        const { target, isIntersecting } = entry;
        if (isIntersecting) {
          setActiveHeading(target.getAttribute('id') || '');
        }
      });
    };

    const callback: IntersectionObserverCallback = (entries) => handleObserverUpdates(entries);

    const observer = new IntersectionObserver(callback, {
      rootMargin: '0px 0px -40% 0px',
    });

    const headingElements = Array.from(document.querySelectorAll('h2'));
    headingElements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, [setActiveHeading]);
};

export default useIntersectionObserver;
